export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 11
	},
	name: "delier7",
	day: 3,
	date: {
		time: "09:33",
		day: "scene.date.text"
	},
	patientState: 0,
	delirium: {
		initialState: "rood",
		clockPosition: {
			x: 785,
			y: 184
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_nacht_ochtend_blinds-dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_nacht_ochtend_blinds-dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_nacht_ochtend_blinds-dicht_wo.flv"
			}
			
		],
		roomViewToggleButtonPosition: {
			x: 866,
			y: 392
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier7/delier7_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier7/delier7_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier7/delier7_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier7/delier7_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 784,
			y: 185
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_slot_blinds_dicht_wo.flv"
			},
			{
				whiteboardState: 4,
				blindsState: 0,
				url: "delier7/${locale}/delier_7_slot_blinds_dicht_do.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier7/${locale}/delier_7_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier7/${locale}/delier_7_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier7/${locale}/delier_7_slot_blinds_open_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 1,
				url: "delier7/${locale}/delier_7_slot_blinds_open_wo.flv"
			},
			{
				whiteboardState: 4,
				blindsState: 1,
				url: "delier7/${locale}/delier_7_slot_blinds_open_do.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "oranje",
			target: "evaluation"
		},
		{
			deliriumState: "rood",
			target: "evaluation"
		},
		{
			deliriumState: "zwart",
			target: "evaluation"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier7/${locale}/delier_7_dialoog_startloop.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "artsaanpatientvoorstellen",
			value: "delier7/${locale}/delier_7_dialoog_benoemenaanwzigheid.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientvragennaarnachtrust",
			value: "delier7/${locale}/delier_7_dialoog_doorvrhallucinatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "vragenofdepatientweetwaarhijis",
			value: "delier7/${locale}/delier_7_dialoog_doorvrorientatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier7/${locale}/delier_7_dialoog_dag.flv"
		}
	]
}